/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Faq_A3Inputs */

const en_minifier_faq_a3 = /** @type {(inputs: Minifier_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, but there will be no size reduction since the JSON is already compact. The output will be identical to the input.`)
};

const ko_minifier_faq_a3 = /** @type {(inputs: Minifier_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네, 하지만 JSON이 이미 최소화되어 있으므로 크기가 줄어들지 않습니다. 출력은 입력과 동일합니다.`)
};

const ja_minifier_faq_a3 = /** @type {(inputs: Minifier_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。ただし、JSONは既にコンパクトなためサイズ削減はありません。出力は入力と同一になります。`)
};

/**
* | output |
* | --- |
* | "Yes, but there will be no size reduction since the JSON is already compact. The output will be identical to the input." |
*
* @param {Minifier_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_faq_a3 = /** @type {((inputs?: Minifier_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_faq_a3(inputs)
	if (locale === "ko") return ko_minifier_faq_a3(inputs)
	return ja_minifier_faq_a3(inputs)
});